import { ChangeDetectionStrategy, Component, inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BaseComponent } from '../../../../../models/base/base-component';
import { Router } from '@angular/router';
import { NavItemViewModel } from './nav-item-view-model';
import { LoadingOptions } from '../../../../../models/shared/loading-options';
import { NavItem } from './models/nav-item';

@Component({
  selector: 'app-nav-item',
  templateUrl: './nav-item.component.html',
  styleUrls: ['./nav-item.component.scss'],
  providers: [NavItemViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavItemComponent extends BaseComponent implements OnChanges {
  @Input() navItem!: NavItem;
  @Input() loadingOpts!: LoadingOptions;

  // TODO: Make this viewModel private
  public viewModel = inject(NavItemViewModel);
  protected router = inject(Router);

  setupViews() {
    this.viewModel.connectToNavItem(this.navItem);
  }

  setupBindings() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.navItem) this.viewModel.connectToNavItem(this.navItem);
    if (changes.loadingOpts) this.viewModel.connectToLoadingOpts(this.loadingOpts);
  }

  navItemSelected() {
    const savedSubNav = this.navItem?.getSavedSubNavItem();
    const extras = { fragment: this.navItem?.savedFragment };
    if (!!savedSubNav) {
      this.router.navigate([`${this.navItem?.routerPath}/${savedSubNav?.relativeRouterPath}`], extras).then(() => {});
    } else {
      this.router.navigate([`${this.navItem?.routerPath}`], extras).then(() => {});
    }
  }
}
